import ShowDetail from "@/components/show-detail";
import type { ShowDetailModalProps } from "./types";

export function ShowDetailModal({
  show,
  onBack,
  onAddToProposal,
  isAuthenticated,
  backToText,
}: ShowDetailModalProps) {
  if (!show) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/50 backdrop-blur-sm"
        onClick={onBack}
      />

      {/* Modal Content */}
      <div className="relative w-full max-w-5xl max-h-[90vh] overflow-y-auto m-4 bg-white rounded-lg shadow-xl p-6">
        <ShowDetail
          show={show}
          onBack={onBack}
          onAddToProposal={onAddToProposal}
          isAuthenticated={isAuthenticated}
          showBackButton={true}
          backToText={backToText}
        />
      </div>
    </div>
  );
}
